import { render } from "./PolicyUpdate.vue?vue&type=template&id=8d20008e&scoped=true"
import script from "./PolicyUpdate.vue?vue&type=script&lang=js"
export * from "./PolicyUpdate.vue?vue&type=script&lang=js"

import "./PolicyUpdate.vue?vue&type=style&index=0&id=8d20008e&scoped=true&lang=css"

import exportComponent from "C:\\projects\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Company\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d20008e"]])

export default __exports__